export default __webpack_public_path__ + "static/media/brico_prive.d0ca8fd8.png";